(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('LocalizationService', LocalizationService);

  LocalizationService.$inject = ['$resource'];
	 function LocalizationService ($resource) {
    return $resource(apiUrl + '/localization/:id', { id: '@id' }, {
      getTimezone: { url: apiUrl + '/localization/timezone', method: 'GET', isArray: false }
    });
  }
})();
